// NOTE: This file was automatically generated by a script. Do not modify this file manually.
// To regenerate this file, please use `pnpm scripts:microbootstrap-generator company_page`
// The command will generate files in the 'frontend/artifacts' folder with the list of files using collections
import { PropsWithChildren } from 'react'

import {
  CollectionBootstrapConfig,
  CollectionsBootstrap as CoreCollectionsBootstrap,
} from 'modules/core/components/CollectionsBootstrap'
import companies from 'modules/core/store/collections/companies'
import features from 'modules/core/store/collections/features'

import atsCompanies from 'modules/ats/store/collections/atsCompanies'
import locations from 'modules/locations/store/collections/locations'

const CollectionsBootstrap = ({ children }: PropsWithChildren) => {
  /* atsCompanies manually fetched by 1 pages in this module */
  const collections: CollectionBootstrapConfig[] = [
    [atsCompanies, {}] /* Referenced by 2 cases in this module */,
    [companies, {}] /* Referenced by 10 cases in this module */,
    [features, {}] /* Referenced by 1 cases in this module */,
    [locations, {}] /* Referenced by 1 cases in this module */,
  ] /* Generated file 👉 artifacts/company_page-module-settings.tsx-collection-dependencies-report-v2.json */

  return <CoreCollectionsBootstrap collections={collections}>{children}</CoreCollectionsBootstrap>
}

export default CollectionsBootstrap
